import { ACCESS_TOKEN_NAME } from "../config/apiConstants";
import { getCookie } from "./getCookie";

export function getToken() {
  return getCookie(ACCESS_TOKEN_NAME);
}
